const TRANSITION = { duration: .28, ease: [.1, .7, .7, 1] };
const SLOW_TRANSITION = { duration: 1, ease: [.1, .7, .7, 1] };

export const PHOTO = {
  initial: { x: -60, opacity: 0 },
  visible: { x: 0, opacity: 1, transition: SLOW_TRANSITION },
  exit: { x: -60, opacity: 0, transition: TRANSITION },
};

export const BRAND = {
  initial: { x: 60, opacity: 0, transition: SLOW_TRANSITION },
  visible: { x: 0, opacity: 1, transition: SLOW_TRANSITION },
  exit: { x: 60, opacity: 0, transition: TRANSITION },
};

export const ACTIONS = {
  initial: { x: 40, opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: { ...SLOW_TRANSITION, delay: .18 },
  },
  exit: { x: 40, opacity: 0, transition: TRANSITION },
};
